import { Text } from "components/common";
import React from "react";
import ReactDOM from "react-dom";

type Props = {
  children: React.ReactNode;
};
export const SharableContent: React.FC<Props> = ({ children }) => {
  return ReactDOM.createPortal(
    <div style={overlayStyles}>
      <Text.Body style={{ marginBottom: "10px" }}>
        Sharing the following stats...
      </Text.Body>
      {children}
    </div>,
    document.getElementById("sharable-root")!,
  );
};

const overlayStyles: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "rgba(0, 0, 0, 1)",
};
